import React, { FC, Fragment } from 'react'
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Text,
  Stack,
} from '@chakra-ui/react'

import { Empty, Loader } from 'components'

import GambiarraFilterTags from 'InstitutionalManagement/components/ProfessionalContractTypeFilterTags'
import CustomFormProfessionalContractTypeCardToSelect from './components/CustomFormProfessionalContractTypeCardToSelect'
import { useCustomFormProfessionalContractTypeSelectionDrawerManager } from '../../contexts/CustomFormProfessionalContractTypeSelectionDrawerManager/Provider'

type Props = {
  onClose: () => void
}

const SelectProfessionalContractTypeOnCustomForm: FC<Props> = ({ onClose }) => {
  const { loadingProfessionalContractTypes, professionalContractTypes, setView, filter, setFilter } =
    useCustomFormProfessionalContractTypeSelectionDrawerManager()

  return (
    <>
      <DrawerCloseButton />

      <DrawerHeader>
        <Text>Tipos de contrato disponíveis</Text>
        <Heading color="primary">Selecione um tipo de contrato</Heading>
      </DrawerHeader>

      <DrawerBody overflowY="auto">
        <GambiarraFilterTags
          px={4}
          pb={4}
          professionalContractTypeFilter={filter}
          setProfessionalContractTypeFilter={setFilter}
        />

        {loadingProfessionalContractTypes ? (
          <Loader text={'Carregando tipos de contrato disponíveis'} />
        ) : (
          <Fragment>
            {professionalContractTypes.length > 0 ? (
              <Stack>
                {professionalContractTypes.map((professionalContractType) => (
                  <CustomFormProfessionalContractTypeCardToSelect
                    key={professionalContractType.id}
                    professionalContractType={professionalContractType}
                    onClose={onClose}
                  />
                ))}
              </Stack>
            ) : (
              <Empty title={'Nenhum tipo de contrato encontrado'} description="Sua busca não retornou registros" />
            )}
          </Fragment>
        )}
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={() => setView('SEARCH_PROFESSIONAL_CONTRACT_TYPE')}>
          Voltar
        </Button>

        <Button onClick={onClose}>Concluir</Button>
      </DrawerFooter>
    </>
  )
}

export default SelectProfessionalContractTypeOnCustomForm
